module.exports = __webpack_public_path__ + "img/ad1.8365fa92.jpg";